import React from "react";
import Link from "gatsby-link";

const SlideItem = ({ item }) => {
  return (
    <Link to={`/products/Detail?${item.type}&${item.urlName.replace(/ /g, "-")}`} className="slide-item">
      <div className="slide-item__container">
        <div className="slide-item__image-wrapper">
          <div className="slide-item__image">
            <img src={item.imgSrc} alt={item.productName} />
          </div>
        </div>
        <div className="slide-item__content">
          <h3 className="slide-item__title">{item.productName}</h3>
          <div className="slide-item__overlay">
            <span className="slide-item__cta">View Details</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SlideItem;



// WEBPACK FOOTER //
// ./src/components/SlideItem.js